module.exports = __webpack_public_path__ + "static/media/ex1.97558b9d.jpg";